module.exports = __webpack_public_path__ + "static/img/thumb_10.358f666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_10.png
// module id = wDyS
// module chunks = 0